module.exports = __webpack_public_path__ + "img/3_5.a559ec40.png";